export default __webpack_public_path__ + "static/media/noUserAvatar.2b3832c8.svg";